const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export function logClientError(error: Error | string, additionalInfo?: Record<string, any>) {
  const errorData = {
    message: typeof error === 'string' ? error : error.message,
    stack: typeof error === 'string' ? undefined : error.stack,
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString(),
    ...additionalInfo,
  };

  // Log to console
  console.error('Client error:', errorData);

  // Send to server (don't await, fire and forget)
  fetch(`${API_URL}/error`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(errorData),
  }).catch((err) => {
    // If error logging fails, just log to console
    console.error('Failed to log error to server:', err);
  });
}

export function setupGlobalErrorHandlers() {
  // Handle uncaught errors
  window.addEventListener('error', (event) => {
    logClientError(event.error || event.message, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    logClientError(
      event.reason instanceof Error ? event.reason : String(event.reason),
      {
        type: 'unhandledRejection',
      }
    );
  });
}
